import { BridgeWrapper } from './BridgeWrapper';
import { connector } from './connect';

const connected = connector(BridgeWrapper);
export { connected as BridgeWrapper };
